import moment from "moment";
import { useEffect, useState } from "react";
import { Alert, Button, Card, Col, Jumbotron, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import Get from "../../api/Get";
import { GET_DOCTOR_BY_SPECIALITY_ACCOUNT_SIN_TOKEN } from "../../api/Routes";
import ComponentModalErrorSever from "../../components/ComponentModalErrorSever";
import ItemsDoctors from "../../components/ItemsDoctors";
import SimpleLoad from "../../loader/SimpleLoad";
import Select from 'react-select'

function SeleccionarFecha({t, cita, handleNext, setInitialData}){
    const [especialidad, setEspecialidad]=useState(cita.speciality)
    const { patientDTO } = cita
    const [basicItems, setBasicItems] = useState([])
    const [items, setItems] = useState([])
    const [isSearch, setIsSearch] = useState(false)
    const [errors, setErrors] = useState(false)
    const [schedule, setSchedule] = useState(null)

    const [startChecking, setStartChecking] = useState([])
    const [checkIndex, setCheckIndex] = useState(-1)
    const [doctors, setDoctors] = useState([])
    const [doctorRef, setDoctorRef] = useState(null)
    const [countDr, setCountDr] = useState(0)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(0)
    const postsPerPage = 10;
    const [indexOfLastPost, setIndexOfLastPost] = useState(currentPage * postsPerPage);
    const [indexOfFirstPost, setIndexOfFirstPost] = useState(indexOfLastPost - postsPerPage);

    const [isSort, setIsSort] = useState(false)

    //server error
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    const ordering = () =>{
        //console.log('ordering')
        let its = [...basicItems]
        //console.log(its)
        its.sort((itA,itB)=>{
            if(itA.values.length > 0 && itB.values.length > 0){
                
                let firstAH = moment(itA.values[0].dateTimeInit, "YYYY-MM-DDTHH:mm:ss")
                let firstBH = moment(itB.values[0].dateTimeInit, "YYYY-MM-DDTHH:mm:ss")
                //console.log(firstAH)
                if(firstAH.isBefore(firstBH)){
                    return -1;
                }else{
                    return 1
                }
            }else if(itA.values.length === 0 && itB.values.length > 0){
                return 1
            }else if(itA.values.length > 0 && itB.values.length === 0){
                return -1
            }else{
                return 0
            }
        })
        setItems(its)
        setIsSort(true)
        
    }   

    useEffect(() => {
        setIsSearch(true)
        Get({url: `${GET_DOCTOR_BY_SPECIALITY_ACCOUNT_SIN_TOKEN}/${especialidad.id}/${patientDTO.account.id}`, noToken: true})
            .then(response=>{
                //console.log(response)
                let its = response.data.data.response.map((it, index)=>({
                    doctor: it.doctor,
                    especialty: it.especialty,
                    formation: it.formation,
                    licence_number: it.licence_number,
                    values: []
                    
                }))
                //console.log(its)
                setStartChecking(its.map((el)=>(el.doctor.id)))
                setDoctors(its.map((el)=>(el.doctor)))
                setCheckIndex(-1)
                setIsSort(false)
                setBasicItems(its)
                setItems(its)
                if(response.data.data.response.length > 0){
                    //let pPage = linkAllianz ? its.length : postsPerPage
                    let pPage = its.length
                    let pC = Math.ceil(its.length / pPage)
                    setPageCount(pC)
                    setCountDr(its.length)
                    setIndexOfFirstPost(0)
                    setIndexOfLastPost(its.length)
                }
                setIsSearch(false)
            })
            .catch(error=>{
                setShowModalError(true)
                if(error.response){
                    setErrorServer(error.response)
                }
            })
        
    }, [especialidad])

    const next = () => {
        handleNext("reasignar")
    }

    const onHandleChangeDoctor = (val) =>{
        let aux1 = [...basicItems]
        if(!val){
            ordering()
        }else{
            let aux = aux1.filter((el)=>el.doctor.id===val.value)
            setItems(aux)
        }
        setDoctorRef(val)
    }
    const handlePageClick = (data) =>{
        setCurrentPage(data.selected+1)
        let indexLastP = (data.selected+1) * postsPerPage
        setIndexOfLastPost(indexLastP)
        setIndexOfFirstPost(indexLastP - postsPerPage)
    }
    const onClickShowCitaPatient = (hour, date, idHour, doctorId) =>{
        let d = items.filter(e=>e.doctor.id===doctorId)
        setInitialData(prev=>({
            ...prev,
            dayAppointment: date, 
            doctorId: doctorId,
            hourDayId: idHour,
            hourDayHour: hour,
            doctorName: `${d[0].doctor.name} ${d[0].doctor.lastName}`,
            especialidadName: especialidad.name,
            especialidadId: especialidad.id
        }))
    }
    const onClickSelectedSchedule = (horario, doctorId) =>{
        let d = items.filter(e=>e.doctor.id===doctorId)
        let schedule = {
            scheduleType:"Online",
            doctor: {
              id: doctorId
            },
            hourInit: moment(horario.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm:ss")
        }
        const dataSchedule = {
            hourInit: moment(horario.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm:ss"),
            schedule: schedule,
            doctorId: doctorId,
            doctorName: `${d[0].doctor.name} ${d[0].doctor.lastName}`,
            especialidadName: especialidad.name,
            especialidadId: especialidad.id
        }
        setInitialData(prev=>({...prev, ...dataSchedule}))
        setSchedule(dataSchedule)
        //next()
    }


    return (
        <>
            <Row>
                <Col>
                <Card className="mb-3">
                    <Card.Body>
                        <Row className="mb-md-4">
                            <Col className="text-right">
                                <Button variant="primary" className="btn1" onClick={next}>{t('siguiente')}</Button>
                            </Col>
                        </Row>
                        { 
                            errors   && 
                            <Alert variant="danger">{t('seleccionar_horario')}</Alert> 
                        }
                        {
                            schedule &&
                            <div className="alert-info p-3 rounded my-3">
                                <label>{t('cita_seleccionada')}</label>
                                <h6 className="mb-0">{t('doctor')}: {schedule.doctorName}</h6>
                                <h6 className="mb-0">{t('fecha')}: {moment(schedule.schedule.hourInit, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY HH:mm")} hrs</h6>
                            </div>                            
                        }
                        {
                            isSearch ? 
                            <Row>
                                <Col className="position-relative overflow-hidden h-300px">
                                    <SimpleLoad />
                                </Col>
                            </Row> :
                            <Row>
                                {
                                    (items.length === 0 && especialidad != null) ?
                                    <Col>
                                        <Jumbotron>
                                            <h1 className="display-3">{t('lo_sentimos')}</h1>
                                            <p>{t('not_found_expecialidad')}</p>
                                        </Jumbotron>
                                    </Col> :
                                    (items.length === 0 && especialidad == null) ?
                                    <Col>
                                        <Jumbotron>
                                            <p>{t('seleccionar_especialidad')}</p>
                                        </Jumbotron>
                                    </Col> :
                                    <Col className="text-style">
                                        <Row>
                                            <Col md="1" xs="12">
                                                <label>Filtrar por nombre</label>
                                            </Col>
                                            <Col md="4" xs="12">
                                                <Select 
                                                    className="select-especialista"
                                                    defaultValue={ doctorRef }
                                                    value={ doctorRef }
                                                    options={ doctors.map(el=>({label: `${el.name} ${el.lastName}`, value: el.id})) }
                                                    onChange= {(val) =>onHandleChangeDoctor(val)}
                                                    isClearable
                                                />
                                            </Col>
                                        </Row>
                                        <ItemsDoctors 
                                            items={items} 
                                            handlePageClick={handlePageClick}
                                            indexOfLastPost={indexOfLastPost}
                                            indexOfFirstPost={indexOfFirstPost}
                                            pageCount={pageCount}
                                            onClickShowCitaPatient={onClickShowCitaPatient}
                                            auth={null}
                                            publico={true}
                                            account={patientDTO.account}
                                            onClickSelectedSchedule={onClickSelectedSchedule}
                                            currentPage={currentPage}
                                            linkAllianz={false}
                                            isSort={isSort}
                                            setIsSort={setIsSort}
                                            ordering={ordering}
                                            startChecking={startChecking}
                                            setStartChecking={setStartChecking}
                                            checkIndex={checkIndex}
                                            setCheckIndex={setCheckIndex}
                                            setBasicItems={setBasicItems}
                                            basicItems={basicItems}
                                            doctorRef={doctorRef}
                                            countDr={countDr}
                                            setCountDr={setCountDr}
                                        />
                                    </Col>
                                }
                                
                            </Row>
                        }
                        
                        <Row className="mt-3">
                            <Col className="text-right">
                                <Button variant="primary" className="btn1" onClick={next}>{t('siguiente')}</Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                </Col>
            </Row>
            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
        </>
    )
}

export default withTranslation()(SeleccionarFecha)